/**
 * Puntitos de la galería de reseñas del home.
 *
 * El carrusel de Judge.me navegaba con flechas y hacía autoplay. Aquí la
 * galería es un scroll horizontal normal (deslizable con el dedo) y los
 * puntitos indican en cuál vas — se pintan según la posición del scroll.
 *
 * Un punto por PANTALLA, no por tarjeta (2-nov-2026): con las reseñas de
 * Judge.me la galería pasa de 1 a decenas de tarjetas, y 40 puntitos ya no
 * navegan nada. Se reconstruye cuando llegan tarjetas nuevas:
 * `window.MaRevsDots.reconstruir()`.
 */
(function () {
  var raiz = document.querySelector('[data-ma-revs]');
  if (!raiz) return;

  var track = raiz.querySelector('[data-ma-revs-track]');
  var cont = raiz.querySelector('[data-ma-revs-dots]');
  if (!track || !cont) return;

  var puntos = [];
  var paginas = 1;
  var MAX_PUNTOS = 10;

  function porPantalla() {
    var card = track.querySelector('.ma-revs__card');
    if (!card) return 1;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    return Math.max(1, Math.floor((track.clientWidth + gap) / (card.offsetWidth + gap)));
  }

  function construir() {
    cont.replaceChildren();
    puntos = [];
    var tarjetas = track.querySelectorAll('.ma-revs__card');
    var pp = porPantalla();
    // Tope de 10: en celular cabe una tarjeta por pantalla y 37 reseñas eran
    // 37 puntitos. Con más pantallas que puntos, cada punto es un TRAMO.
    paginas = Math.min(MAX_PUNTOS, Math.ceil(tarjetas.length / pp));
    if (paginas < 2) return;
    for (var i = 0; i < paginas; i++) {
      (function (n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ma-revs__dot';
        b.setAttribute('aria-label', 'Ver reseñas, página ' + (n + 1) + ' de ' + paginas);
        b.addEventListener('click', function () {
          var max = track.scrollWidth - track.clientWidth;
          track.scrollTo({ left: Math.round((n / (paginas - 1)) * max), behavior: 'smooth' });
        });
        cont.appendChild(b);
        puntos.push(b);
      })(i);
    }
    pintar();
  }

  function pintar() {
    if (!puntos.length) return;
    var max = track.scrollWidth - track.clientWidth;
    var i = max > 0 ? Math.round((track.scrollLeft / max) * (paginas - 1)) : 0;
    puntos.forEach(function (p, n) {
      var on = n === i;
      p.classList.toggle('is-active', on);
      p.setAttribute('aria-current', on ? 'true' : 'false');
    });
  }

  // Cálculo directo, no en requestAnimationFrame: diferirlo dejaba el fade de
  // los carruseles trabado (ver docs/LEARNINGS.md).
  track.addEventListener('scroll', pintar, { passive: true });
  window.addEventListener('resize', construir);
  window.MaRevsDots = { reconstruir: construir };
  construir();
})();
